// extracted by mini-css-extract-plugin
export default {"container_360":"search_container_360__yZyvO","service360_container":"search_service360_container__elxgf","form":"search_form__wV61j","pair":"search_pair__93xIW"};